import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { DeleteAddButtons } from '../inputs/deleteAddButtons'
import classes from './index.module.scss'

export const IndustryItem = ({ level, industries, handleDeleteItem }) => {
  return (
    <Element className={classes.item}>
      <Element className={classes.level} style={{ backgroundColor: '#F3F3F3' }}>
        <Translate value="screening.LEVEL" /> {level}
      </Element>
      <Element className="flex1">
        {industries.map((item) => (
          <Element key={item.id} className={classes.industry}>
            <Element className={classes.code}>{item.code}</Element>
            <Element className={classes.name}>{item.name}</Element>
            <DeleteAddButtons
              onDeleteBtnClick={() => handleDeleteItem(item.id)}
            />
          </Element>
        ))}
      </Element>
    </Element>
  )
}
